import axios from "axios";
import { useEffect, useState } from "react";
import { getDecryptedData, storeEncryptedData } from "../config/crypto";
import { REACT_APP_API_PORT } from "../Api";

const RazorpayPayment = ({ amount, currency = "INR", name, email, onSuccess, onFailure, id }) => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    const createOrder = async () => {
        try {
            let token = getDecryptedData("token")
            const response = await axios.post(`${REACT_APP_API_PORT}user/course/order/user-paid-course-purchase/${id}`, { amount, currency }, {
                headers: {
                    "Content-Type": "application/json",
                    'x-access-token': token,
                },

            });

            if (response.data.status) {
                storeEncryptedData("COID", response?.data?.data?._id)
                storeEncryptedData("OID", response?.data?.orderId)
                return response.data?.orderId; // Order ID from backend
            }
        } catch (error) {
            console.error("Error creating order:", error);
            if (error?.response?.data?.status === false) {
                alert(error?.response?.data?.message)
            }
            return null;
        }
    };

    const handlePayment = async () => {
        if (!window.Razorpay) {
            alert("Razorpay SDK failed to load. Check your internet connection.");
            return;
        }

        setLoading(true);
        const orderId = await createOrder();
        setLoading(false);

        if (!orderId) {
            alert("Failed to create order. Try again.");
            return;
        }

        const options = {
            key: "rzp_test_12rYyFhgf3GusJ", // Replace with your Razorpay key
            amount: amount * 100, // Razorpay expects amount in paise
            currency,
            name: "Next Future AI",
            description: "Payment for course purchase",
            order_id: orderId, // From backend
            handler: function (response) {
                onSuccess(response);
            },
            prefill: {
                name: name,
                email: email,
                contact: ""
            },
            theme: {
                // color: "#3399cc",
                // color:"#0068ff"
                color: "#161616"
            },
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.on("payment.failed", function (response) {
            onFailure(response);
        });
        paymentObject.open();
    };

    return (
        <>
            {/* <button
      className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition"
      onClick={handlePayment}
      disabled={loading}
    >
      {loading ? "Processing..." : "Pay Now"}
    </button > */}
            <button
                type='button'
                onClick={handlePayment}
                disabled={loading}
                className="mt-2 border-2 border-customBlue  bg-blue-600  px-4 py-3 rounded text-white   hover:bg-background-primary transition text-[15px] font-bold uppercase w-full"
            >
                {loading ? "Processing..." : "Pay Now"}
            </button>
        </>
    );
};

export default RazorpayPayment;
